// extracted by mini-css-extract-plugin
export var button = "_ca-0";
export var donut = "_ca-1";
export var donutFill = "_ca-3";
export var donutTrack = "_ca-2";